<template>
  <div class="" >
    <div class="notice notice-warm m1111">
      本例需要在手机下查看
    </div>
  </div>
</template>

<script>
import List from './list'

export default {
  name: 'listdemo',
  components: {
    List
  },
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// demo.vue?61024c8c